// apps/blend-food/src/environments/environment.dev.ts
export const environment = {
  name: 'dev',
  production: false,
  apiBaseUrl: 'https://api-dev.menuhubdelivery.cloud',
  authStorageKey: 'blend-food.auth',
} as const;
